import { Global, css } from '@emotion/react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { getCMSData } from '@actions/careers';
import Banner from './Banner';
import Stats from './Stats';
import SlideShow from './SlideShow';
import PillarsOfLeadership from './PillarsOfLeadership';
import TeamTestimonials from './TeamTestimonials';
import WhyUnacademy from './WhyUnacademy';
import YoutubeVideo from './YoutubeVideo';

const GlobalCSS = css`
  html {
    scroll-behavior: smooth;
  }
`;
const Career = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCMSData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Global styles={GlobalCSS} />
      <Banner />
      <Stats />
      <SlideShow />
      <PillarsOfLeadership />
      <TeamTestimonials />
      <WhyUnacademy />
      <YoutubeVideo />
    </>
  );
};

export default Career;
